import { useQuery } from "@tanstack/react-query";
import { getMediaGenerateStatus } from "#/api/mediaReference.api";

export function useMediaGenerateStatus(
  requestId: string | null,
  enabled: boolean
) {
  return useQuery({
    queryKey: ["media", "generate", requestId],
    queryFn: () => {
      if (!requestId) {
        throw new Error("Request id required");
      }
      return getMediaGenerateStatus(requestId);
    },
    enabled: Boolean(requestId && enabled),
    refetchInterval: 3000,
    staleTime: 0,
  });
}
